import React from 'react';
import './MessageOutput.scss'

export default function MessageOutput({ children }){
    return (
        <div className="message-output">
            { children }    
        </div>
    )
}